import { CupModePoints } from "model/Match/Set/CupMode/Format/CupModePoints";
import { mapPointsDistribution } from "../FsPointsDistribution";
import {
  FsCupModePoints,
  isFsStaticCupModePoints,
} from "db/model/match/Set/CupMode/FsCupModePoints";

export const mapCupModePoints = (
  fsModel: FsCupModePoints
): CupModePoints | undefined => {
  if (isFsStaticCupModePoints(fsModel)) {
    return mapPointsDistribution(fsModel);
  }

  const keys = Object.keys(fsModel);
  const cupModePoints: CupModePoints = {};
  for (var i = 0; i < keys.length; i++) {
    const numLeft = keys[i];
    const fsPointsDist = fsModel[numLeft];
    if (!fsPointsDist) {
      continue;
    }

    const pointsDist = mapPointsDistribution(fsPointsDist);
    if (!pointsDist) {
      continue;
    }

    cupModePoints[numLeft] = pointsDist;
  }

  return cupModePoints;
};
